import { PencilIcon, TrashIcon } from "@heroicons/react/24/outline";
import { IconButton } from "../../../../../../../components/ui/IconButton";
import { Modal } from "../../../../../../../components/ui/Modal";
import AddRecord from "./AddRecord";
import DeleteRecord from "./DeleteRecord";

const Actions = props => {
  const { id: materialId, values, artwork } = props;
  const editModalProps = {
    body: AddRecord,
    hideCloseButton: true,
    closeOnBackdrop: false,
    scale: "md",
    values,
    artwork,
  };

  const deleteModalProps = {
    body: DeleteRecord,
    description: "Are you sure?",
    scale: "sm",
    hideCloseButton: true,
    closeOnBackdrop: false,
    materialId,
  };

  if (!materialId) {
    return null;
  }

  return (
    <div className="user-list-actions flex text-right text-sm font-medium">
      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4">
        <Modal {...editModalProps}>
          <IconButton variant="clean" title="Edit Record">
            <PencilIcon className={`h-4 w-4 cursor-pointer text-gray-400`} />
          </IconButton>
        </Modal>
        <Modal {...deleteModalProps}>
          <IconButton variant="clean" title="Delete Record">
            <TrashIcon className={`h-4 w-4 cursor-pointer text-gray-400`} />
          </IconButton>
        </Modal>
      </div>
    </div>
  );
};

export default Actions;
